module.exports = __webpack_public_path__ + "static/media/ray3.3c6108d1.jpg";